import { useState, useEffect, useSyncExternalStore } from 'react';

function subscribe(callback) {
	const observer = new MutationObserver(callback);
	observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
	return () => observer.disconnect();
}

function getSnapshot() {
	return document.documentElement.classList.contains('dark');
}

/**
 * Hook to observe dark mode state from the `dark` class on <html>.
 * Uses a single MutationObserver shared across all consumers.
 */
export function useDarkMode() {
	return useSyncExternalStore(subscribe, getSnapshot);
}
